import { Rive } from "@rive-app/canvas";
import Swiper from "swiper";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// document ready in vanilla js
document.addEventListener("DOMContentLoaded", function () {
  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  // check for inline sizeload videos
  let sizeloadVideos = document.querySelectorAll(".sizeload");
  sizeloadVideos.forEach((video) => {
    sizeloadVideo(video, "yes");
  });

  // GSAP ScrollTrigger for headline_columns
  let headlineColumns = document.querySelectorAll(".headline_columns");

  headlineColumns.forEach((column) => {
    // for mobile we are making the headlines and paragraphs the same height to create a grid
    if (innerWidth < 768) {
      // find the tallest paragraph in the section and apply that height to all the paragraphs
      let paragraphs = column.querySelectorAll("p");
      let tallest = 0;
      paragraphs.forEach((p) => {
        if (p.clientHeight > tallest) {
          tallest = p.clientHeight;
        }
      });
      paragraphs.forEach((p) => {
        p.style.height = tallest + "px";
      });

      // find the tallest headline in the section and apply that height to all the headlines
      let headlines = column.querySelectorAll("h2");
      tallest = 0;
      headlines.forEach((h) => {
        if (h.clientHeight > tallest) {
          tallest = h.clientHeight;
        }
      });
      headlines.forEach((h) => {
        h.style.height = tallest + "px";
      });
    }

    // animating the logo color when over white background
    gsap.from(column, {
      scrollTrigger: {
        trigger: column,
        start: "top-=100 top",
        end: "bottom-=100 top",
        toggleActions: "play none none none",
        onEnter: () => document.body.classList.add("headline-visible"),
        onLeave: () => document.body.classList.remove("headline-visible"),
        onEnterBack: () => document.body.classList.add("headline-visible"),
        onLeaveBack: () => document.body.classList.remove("headline-visible"),
      },
    });
  });

  /*
  // horizontal scroll

  function hScrollInit() {
    const scrollContainer = document.querySelector(".horz_scroll");

    if (typeof scrollContainer != "undefined" && scrollContainer != null) {
      // mouse wheel event listener for scrolling
      scrollContainer.addEventListener("wheel", (evt) => {
        scrollContainer.scrollLeft += evt.deltaY;
      });
    }
  }

  hScrollInit();

  */

  //Horizontal scroll on mobile

  let scrollContainer = document.querySelector(".horz_scroll");
  let nextBtn = document.querySelector(".horz_scroll_wrap .arrows .next");
  let prevBtn = document.querySelector(".horz_scroll_wrap .arrows .prev");
  if (typeof nextBtn != "undefined" && nextBtn != null) {
    nextBtn.addEventListener("click", function (e) {
      scrollContainer.scrollLeft += 200;
    });
    prevBtn.addEventListener("click", function (e) {
      scrollContainer.scrollLeft -= 200;
    });
  }

  // swiper slideshow

  let slideshowEls = document.querySelectorAll(".slideshow.swiper");

  // if no slideshow found set the main element to 100% opacity
  if (slideshowEls.length == 0) {
    document.querySelector("main").style.opacity = 1;
  }

  slideshowEls.forEach((slideshowEl) => {
    let slideshow;

    // loop through each slide and find the smallest data-padding value
    let slides = slideshowEl.querySelectorAll(".cell");
    let padding = 0;
    slides.forEach((slide) => {
      let media = slide.querySelector(".media");
      let slidePadding = media.getAttribute("data-padding");
      if (slidePadding < padding || padding === 0) {
        padding = slidePadding;
      }
    });

    // set all slide media elements to the smallest padding value
    slides.forEach((slide) => {
      let media = slide.querySelector(".media");
      media.style.paddingTop = padding + "%";
    });

    // fade the main element on now that slideshow size has been set
    document.querySelector("main").style.opacity = 1;

    slideshow = new Swiper(slideshowEl, {
      modules: [Pagination, EffectFade, Autoplay],
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      effect: "fade",
      speed: 500,
      loop: true,
      on: {
        init: function () {
          // count the number of slides
          let totalSlides = this.slides.length;
          // divide the width of the screen by the totalSlides to set the width of the pager dots
          let pagerWidth = 100 / totalSlides;
          // set the width of the pager dots
          document
            .querySelectorAll(".swiper-pagination-bullet")
            .forEach((el) => {
              el.style.width = pagerWidth + "%";
            });
        },
      },
    });

    let slideTimer;

    // handle slide change event
    slideshow.on("slideChange", function () {
      clearTimeout(slideTimer);

      let currentSlide = this.slides[this.activeIndex];
      let video = currentSlide.querySelector("video");
      if (typeof video != "undefined" && video != null) {
        video.play();
        let videoDuration = video.getAttribute("data-duration");
        videoDuration = videoDuration * 1000 - 500;
        changeSlide(videoDuration);
      } else {
        changeSlide(4000);
      }
    });

    // custom changeSlide function to transition based on video duration
    function changeSlide(duration) {
      slideTimer = setTimeout(() => {
        slideshow.slideNext();
      }, duration);
    }
  });

  // testing the RIV animation

  let animationCanvas = document.querySelectorAll(".riv_canvas");

  animationCanvas.forEach((canvas) => {
    const file = canvas.getAttribute("data-file");

    const r = new Rive({
      src: "/downloads/" + file,
      canvas: canvas,
      stateMachines: "State Machine 1",
      autoplay: true,
      onLoad: () => {
        r.resizeDrawingSurfaceToCanvas();
      },
    });
  });

  // Work page nav filter clicks for mobile
  let filter = document.querySelector(".gridpage .filter");
  if (typeof filter != "undefined" && filter != null) {
    filter.addEventListener("click", function () {
      filter.classList.toggle("open");
    });
  }
});
